import { items as neww } from './data/new';
import { items as other } from './data/other';
import { items as renovation } from './data/renovation';

export const items = [
    ...renovation,
    ...neww,
    ...other
];
